export const refJenisNasabah = [
    { value: "10-Perseorangan", label: "Perseorangan" },
    { value: "11-Masyarakat", label: "Masyarakat" },
    { value: "20-Perusahaan", label: "Company" },
    { value: "30-Koperasi", label: "Koperasi/BMT" },
    { value: "40-Bank Umum", label: "Bank Umum" },
    { value: "50-Bank Syariah", label: "Bank Syariah" },
    { value: "51-Unit Usaha Syariah", label: "Unit Usaha Syariah" },
    { value: "60-BPR Konvensional", label: "BPR Konvensional" },
    { value: "70-BPR Syariah", label: "BPR Syariah" },
    { value: "80-Yayasan Dana Pensiun", label: "Yayasan Dana Pensiun" },
];
export const refJenisIdentitas = [
    { value: "1-KTP", label: "KTP" },
    { value: "2-Paspor", label: "Paspor" },
    { value: "3-NPWP", label: "NPWP" },
    { value: "9-Lainnya", label: "Lainnya" },
];
export const refJenisIdentitasPenjamin = [
    { value: "1-KTP", label: "KTP / WNI" },
    { value: "2-Paspor", label: "Paspor / WNA" },
    { value: "3-NPWP", label: "NPWP / Badan Usaha" },
    { value: "9-Lainnya", label: "Lainnya" },
];
export const refStatusEBanking = [
    { value: "active", label: "Aktif" },
    { value: "inactive", label: "Tidak Aktif" },
];
export const refStatusRekening = [
    { value: "10-Baru", label: "New" },
    { value: "14-Approved", label: "Disetujui" },
    { value: "15-Rejected", label: "Ditolak" },
    { value: "19-Canceled", label: "Dibatalkan" },
    { value: "20-Aktif", label: "Active" },
    { value: "23-Aro", label: "Perpanjangan" },
    { value: "25-Restruktur", label: "Restruktrur" },
    { value: "31-Write Off", label: "WriteOff" },
    { value: "34-Channeling", label: "Channeling" },
    { value: "35-Restruktur", label: "Restruktrur" },
    { value: "37-Bill Off", label: "Hapus Tagih" },
    { value: "38-Ayda", label: "AYDA" },
    { value: "39-Tutup", label: "Closed" },
];
export const refStatusBmpk = [
    {
        value: "00-Tidak Melanggar dan Tidak Melampaui",
        label: "Tidak Melanggar dan Tidak Melampaui",
    },
    { value: "11-Melanggar Individu", label: "Melanggar Individu" },
    { value: "12-Melanggar Kelompok", label: "Melanggar Kelompok" },
    {
        value: "13-Melanggar Individu dan Kelompok",
        label: "Melanggar Individu dan Kelompok",
    },
    { value: "21-Melampaui Individu", label: "Melampaui Individu" },
    { value: "22-Melampaui Kelompok", label: "Melampaui Kelompok" },
    {
        value: "23-Melampaui Individu dan Kelompok",
        label: "Melampaui Individu dan Kelompok",
    },
];
export const refStatusPeserta = [
    { value: "1", label: "Arranger" },
    { value: "2", label: "Anggota Sidikasi" },
];
export const refGender = [
    { value: "1-Laki", label: "Laki-laki" },
    { value: "2-Perempuan", label: "Perempuan" },
    // { value: "3-BadanUsaha", label: "Badan Usaha" },
    // { value: "4-Masyarakat", label: "Masyarakat" },
];
export const refMarital = [
    { value: "1-Kawin", label: "Married" },
    { value: "2-BelumKawin", label: "Single" },
    { value: "3-Duda/Janda", label: "Widower/Widow" },
    { value: "4-Cerai Mati", label: "Cerai Mati" },
];
export const refReligion = [
    { value: "1-Islam", label: "Islam" },
    { value: "2-Kristen Katolik", label: "Catholic" },
    { value: "3-Kristen Protestan", label: "Protestant" },
    { value: "4-Hindu", label: "Hindu" },
    { value: "5-Budha", label: "Buddha" },
    { value: "6-lain-Lain", label: "Other" },
];
export const refGoPublic = [
    { value: "Y", label: "Yes" },
    { value: "T", label: "No" },
];
export const refJenisProduk = [
    { value: "10-KYD Non Bank", label: "Loan Given" },
    { value: "11-KYD ABA", label: "ABA Loan Given" },
    { value: "12-KYD Channeling", label: "Channeling Loan" },
    { value: "13-KYD Sindikasi", label: "Loan Syndication" },
    { value: "17-KYD Administratif", label: "Pinjaman Administratif" },
    { value: "20-KYT Subordinasi", label: "Subordinated Borrowings" },
    { value: "21-KYT Lainnya", label: "Other Borrowings" },
    { value: "22-KYT ABP Linkage", label: "ABP-Linkage Borrowings" },
    { value: "23-KYT ABP Khusus", label: "ABP-Special Borrowings" },
    { value: "24-KYT ABP Lainnya", label: "ABP-Other Borrowings" },
];
export const refJenisPembiayaan = [
    { value: "e13-Investasi", label: "Pembiayaan Investasi" },
    { value: "e14-Modal Kerja", label: "Pembiayaan Modal Kerja" },
    { value: "e52-Multi Guna", label: "Pembiayaan Multi Guna" },
    { value: "e53-Syariah", label: "Pembiayaan Berdasarkan Prinsip Syariah" },
    {
        value: "e25-Jual Beli Syariah",
        label: "Pembiayaan Jual Beli Berdasarkan Prinsip Syariah",
    },
    {
        value: "e30-Investasi Syariah",
        label: "Pembiayaan Investasi Berdasarkan Prinsip Syariah",
    },
    {
        value: "e36-Jasa Syariah",
        label: "Pembiayaan Jasa Berdasarkan Prinsip Syariah",
    },
    {
        value: "e54-Lainnya OJK",
        label: "Pembiayaan Lainnya Berdasarkan Persetujuan OJK",
    },
];
export const refKolektibilitasJenis = [
    { value: "1-Umum", label: "Umum" },
    { value: "2-KPR", label: "KPR" },
];
export const refKolektibilitasMinimum = [
    { value: "1-Lancar", label: "1-Fluent" },
    { value: "2-Dalam Perhatian Khusus", label: "2-SpecialMention" },
    { value: "3-Kurang Lancar", label: "3-Substandard" },
    { value: "4-Diragukan", label: "4-Doubtful" },
    { value: "5-Macet", label: "5-Stuck" },
];
export const refKolektibilitasOveride = [
    { value: "0-Default", label: "0-Default" },
    { value: "1-Lancar", label: "1-Fluent" },
    { value: "2-Dalam Perhatian Khusus", label: "2-SpecialMention" },
    { value: "3-Kurang Lancar", label: "3-Substandard" },
    { value: "4-Diragukan", label: "4-Doubtful" },
    { value: "5-Macet", label: "5-Stuck" },
];
export const refHitungPpap = [
    { value: "Y", label: "Ya" },
    { value: "T", label: "Tidak" },
];
export const refTypeKredit = [
    { value: "100", label: "100-Flat" },
    { value: "130", label: "130-Flat Pokok Diakhir" },
    { value: "131", label: "131-Flat Pokok Diakhir Bunga Nol" },
    { value: "140", label: "140-Flat Beginning Rate Ending Principal" },
    { value: "141", label: "141-Flat Beginning Rate Ending Principal" },
    { value: "150", label: "150-Flat Beginning Rate" },
    { value: "170", label: "170-Flat To Anuitas" },
    { value: "200", label: "200-Decreased OS Principal" },
    { value: "300", label: "300-Decreased Expired Principal" },
    { value: "331", label: "331-Menurun Pokok Diakhir Bunga Nol" },
    { value: "500", label: "500-Account" },
    { value: "530", label: "530-Rate Dailiy Beginning Principal At The End" },
    { value: "550", label: "550-Rate Dailiy Fixed" },
    { value: "700", label: "700-Annuity" },
    { value: "710", label: "710-Annuity To Flat" },
    { value: "720", label: "720-Yearly Annuity" },
    { value: "790", label: "790-Sum Annuity 78" },
    { value: "900", label: "900-Decreased Fix Loan" },
];
export const refAlokasiBunga = [
    { value: "10-Tunggakan", label: "Overdue" },
    { value: "20-Plafond", label: "Plafond" },
    { value: "30-OB Tabungan", label: "OB Tabungan" },
];
export const refAlokasiBungaBreak = [
    { value: "1-Tidak Diberikan", label: "Tidak Diberikan" },
];
export const refAlokasiBungaDate = [
    { value: "10-Akhir Bulan", label: "Akhir Bulan" },
    { value: "20-Tgl Angsuran", label: "Tgl Angsuran" },
];
export const refSatuanWaktuAngsuran = [
    { value: "1-Harian", label: "Daily" },
    { value: "2-Pasaran", label: "MarketDay" },
    { value: "3-Mingguan", label: "Weekly" },
    { value: "4-Bulanan", label: "Monthly" },
];
export const refJenisAngsuran = [
    { value: "10-In Arrears", label: "In Arrears" },
    { value: "20-In Advance", label: "In Advance" },
];
export const refJenisAgunan = [
    { value: "0-Pilih", label: "Choose" },
    { value: "1-Logam Mulia", label: "Precious Metals" },
    { value: "2-Rekening", label: "Account" },
    { value: "3-Tanah", label: "Land" },
    { value: "5-SK PNS", label: "SKPNS" },
    { value: "6-SK Gaji", label: "SK Salary" },
    { value: "7-Kios/Bangunan", label: "Kiosk/Place Of Business" },
    { value: "8-Tanah/Bangunan/Rumah", label: "Land Buildings Home" },
];
export const refJenisSukuBunga = [
    { value: "1-Fixed", label: "Fixed" },
    { value: "2-Progressive", label: "Progressive" },
    { value: "3-Floating", label: "Floating" },
];
export const refBaseDenda = [
    { value: "1-Tanpa Denda", label: "Without Fine" },
    { value: "2-Pokok", label: "Principal" },
    { value: "3-Bunga", label: "Margin" },
    { value: "4-Pokok Bunga", label: "Margin Principal" },
    { value: "5-Pokok Bunga Admin", label: "Margin Principal Admin" },
];
export const refBaseDendaJt = [
    {
        value: "00-Sama Dengan Sebelum JT Pinjaman",
        label: "Sama Dengan Sebelum JT Pinjaman",
    },
    {
        value: "01-Denda Pokok Dari Jml Bulan Tertunggak Dari JT",
        label: "Denda Pokok Dari Jml Bulan Tertunggak Dari JT ",
    },
    { value: "99-Denda Off", label: "Denda Berhenti (Tidak Dikenakan)" },
];
export const refPeriodeDenda = [
    { value: "1-Akumulasi Per Hari", label: "Days Accumulated" },
    { value: "2-Akumulasi Per Angs", label: "Installment Accumulated" },
    { value: "3-Akumulasi Per Bulan", label: "Month Accumulated" },
    { value: "4-Per Hari", label: "Per Days" },
    { value: "5-Per Angs", label: "Per Installment" },
    { value: "6-Per Bulan", label: "Per Month" },
];
export const refCaraHitungBunga = [
    { value: "1-Flat", label: "Flat A Year" },
    { value: "2-Efektif", label: "Effective A Year" },
    { value: "3-Margin", label: "Margin" },
    { value: "4-Angsuran", label: "Amount Installment" },
    { value: "5-SukuBungaPerAngsuran", label: "Rate Installment" },
];
export const refBungaLudin = [
    { value: "00-Sisa Bunga", label: "Rate Residue" },
    { value: "11-Bunga 1 Bulan", label: "Rate 1 Month" },
    { value: "12-Bunga 2 Bulan", label: "Rate 2 Month" },
    { value: "13-Bunga 3 Bulan", label: "Rate 3 Month" },
    { value: "14-Bunga 4 Bulan", label: "Rate 4 Month" },
    { value: "15-Bunga 5 Bulan", label: "Rate 5 Month" },
    { value: "16-Bunga 6 Bulan", label: "Rate 6 Month" },
    {
        value: "20-Sisa Hari Per Total Hari x Jml Bunga",
        label: "Sisa Hari Per Total Hari x Jml Bunga",
    },
    {
        value: "27-Sisa Hari Per Total Hari x Jml Bunga Min 7",
        label: "Sisa Hari Per Total Hari x Jml Bunga Min 7",
    },
    { value: "30-Bunga Harian", label: "Rate On Days" },
    { value: "99-Bunga Dihapuskan", label: "Bunga Dihapuskan" },
];
export const refPenaltiLudin = [
    { value: "00-Sisa Bunga", label: "Rate Residue" },
    { value: "11-Bunga 1 Bulan", label: "Rate 1 Month" },
    { value: "12-Bunga 2 Bulan", label: "Rate 2 Month" },
    { value: "13-Bunga 3 Bulan", label: "Rate 3 Month" },
    { value: "14-Bunga 4 Bulan", label: "Rate 4 Month" },
    { value: "15-Bunga 5 Bulan", label: "Rate 5 Month" },
    { value: "16-Bunga 6 Bulan", label: "Rate 6 Month" },
    {
        value: "20-Sisa Hari Per Total Hari x Jml Bunga",
        label: "Sisa Hari Per Total Hari x Jml Bunga",
    },
    {
        value: "27-Sisa Hari Per Total Hari x Jml Bunga Min 7",
        label: "Sisa Hari Per Total Hari x Jml Bunga Min 7",
    },
    { value: "30-Bunga Harian", label: "Rate On Days" },
    { value: "99-Tidak Dikenakan", label: "Tidak Dikenakan" },
];
export const refJenisPotonganBiaya = [
    { value: "00-Potong Plafond", label: "DP dan Biaya Potong Plafond" },
    {
        value: "01-Potong Plafond DP Supplier",
        label: "DP Ke supplier Biaya Potong Plafond",
    },
    { value: "10-Dimuka", label: "DP dan Biaya Ke Lembaga Dimuka" },
    { value: "11-Dimuka Supplier", label: "DP dan Biaya Ke Supplier Dimuka" },
    {
        value: "12-Dimuka DP Supplier",
        label: "DP Ke supplier Biaya Ke lembaga Dimuka",
    },
];
export const refJenisPerhitunganPremi = [
    { value: "10-Persentase Pokok Pinjaman", label: "Persentase Pokok Pinjaman" },
    { value: "11-Persentase HPP", label: "Persentase HPP" },
];
export const refJenisScalePokok = [
    { value: "10-Round", label: "Rounding" },
    { value: "20-Fraction", label: "Fractions" },
    { value: "22-FractionUp", label: "Fractions Up" },
];
export const refJenisScaleBunga = [
    { value: "10-Round", label: "Rounding" },
    { value: "20-Fraction", label: "Fractions" },
    { value: "22-FractionUp", label: "Fractions Up" },
];
export const refJenisScaleAdmin = [
    { value: "10-Round", label: "Rounding" },
    { value: "20-Fraction", label: "Fractions" },
    { value: "22-FractionUp", label: "Fractions Up" },
];
export const refJenisScaleAngsuran = [
    { value: "10-Round", label: "Rounding" },
    { value: "20-Fraction", label: "Fractions" },
    { value: "22-FractionUp", label: "Fractions Up" },
];
export const refDistribusiBasil = [
    { value: "Ya", label: "Yes" },
    { value: "Tidak", label: "No" },
];
export const refFlagShu = [
    { value: "1-Tidak", label: "No" },
    { value: "2-Khusus Anggota", label: "Members Only" },
    { value: "3-Semua Nasabah", label: "All Customer" },
];
export const refSukuBunga = [
    { value: "1-Fixed", label: "Fixed" },
    { value: "2-Progressive", label: "Progressive" },
    { value: "3-Floating", label: "Floating" },
    { value: "19-Canceled", label: "Dibatalkan" },
    { value: "20-Aktif", label: "Active" },
    { value: "23-Aro", label: "Perpanjangan" },
    { value: "25-Restruktur", label: "Restruktrur" },
    { value: "31-Write Off", label: "WriteOff" },
    { value: "34-Channeling", label: "Channeling" },
    { value: "35-Restruktur", label: "Restruktrur" },
    { value: "37-Bill Off", label: "Hapus Tagih" },
    { value: "38-Ayda", label: "AYDA" },
    { value: "39-Tutup", label: "Closed" },
];
export const refAddRowAgunan = [
    { value: "0-Pilih", label: "Tanpa Agunan" },
    { value: "1-Logam Mulia", label: "Precious Metals" },
    { value: "2-Rekening", label: "Account" },
    { value: "3-Tanah", label: "Land" },
    { value: "4-Kendaraan", label: "Vehicle" },
    { value: "5-SK PNS", label: "SKPNS" },
    { value: "6-SK Gaji", label: "SK Salary" },
    { value: "7-Kios/Bangunan", label: "Kiosk/Place Of Business" },
    { value: "8-Tanah/Bangunan/Rumah", label: "Land Buildings Home" },
    { value: "9-Piutang", label: "Piutang (Invoice)" },
    { value: "10-Alat Berat", label: "Alat Berat" },
    { value: "11-Mesin", label: "Mesin" },
    { value: "12-Kapal Laut", label: "Kapal Laut" },
    { value: "13-JAMSOSTEK", label: "JAMSOSTEK" },
    { value: "14-IJAZAH", label: "IJAZAH" },
];
export const refBiSumberDanaPelunasan = [
    { value: "10-Gaji", label: "10-Salary" },
    { value: "21-Usaha Subsidi", label: "21-Subsidy Business" },
    { value: "22-Usaha Non Subsidi", label: "22-Non Subsidy Business" },
    { value: "31-Lainnya Subsidi", label: "31-Other Subsidy" },
    { value: "32-Lainnya Non Subsidi", label: "32-Other Non Subsidy" },
];
export const refBiJenisUsaha = [
    { value: "1-Mikro", label: "1-Micro" },
    { value: "2-Kecil", label: "2-Small" },
    { value: "3-Menengah", label: "3-Middle" },
    {
        value: "4-Selain Usaha Mikro Kecil dan Menengah",
        label: "4-Other Small Micro And Middle Bussiness",
    },
];
export const refBiJenisUsahaBerkelanjutan = [
    { value: "EN:e3819-Energi Terbarukan", label: "Energi Terbarukan" },
    { value: "EN:e3820-Efisiensi energi", label: "Efisiensi energi" },
    {
        value: "EN:e3821-Pencegahan dan Pengendalian Polusi",
        label: "Pencegahan dan Pengendalian Polusi",
    },
    {
        value: "EN:e3822-Pengelolaan Sumber Daya Alam Hayati dan Penggunaan Lahan Yang Berkelanjutan",
        label: "Pengelolaan Sumber Daya Alam Hayati dan Penggunaan Lahan Yang Berkelanjutan",
    },
    {
        value: "EN:e3823-Konservasi Keanekaragaman Hayati Darat dan Air",
        label: "Konservasi Keanekaragaman Hayati Darat dan Air",
    },
    {
        value: "EN:e3824-Transportasi Ramah Lingkungan",
        label: "Transportasi Ramah Lingkungan",
    },
    {
        value: "EN:e3825-Pengelolaan Air dan Air Limbah yang Berkelanjutan",
        label: "Pengelolaan Air dan Air Limbah yang Berkelanjutan",
    },
    {
        value: "EN:e3826-Adaptasi perubahan iklim",
        label: "Adaptasi perubahan iklim",
    },
    {
        value: "EN:e3827-Produk yang Dapat Mengurangi Penggunaan Sumber Daya Dan Menghasilkan Sedikit Polusi (Eco-efficient)",
        label: "Produk yang Dapat Mengurangi Penggunaan Sumber Daya Dan Menghasilkan Sedikit Polusi (Eco-efficient)",
    },
    {
        value: "EN:e3828-Bangunan Berwawasan Lingkungan yang Memenuhi Standar atau Sertifikasi yang Diakui secara Nasional, Regional, atau Internasional",
        label: "Bangunan Berwawasan Lingkungan yang Memenuhi Standar atau Sertifikasi yang Diakui secara Nasional, Regional, atau Internasional",
    },
    {
        value: "EN:e3829-Kegiatan Usaha dan/atau Kegiatan Lain yang Berwawasan Lingkungan Lainnya",
        label: "Kegiatan Usaha dan/atau Kegiatan Lain yang Berwawasan Lingkungan Lainnya",
    },
    {
        value: "EN:e3830-Kegiatan Usaha Mikro, Kecil, dan Menengah (UMKM)",
        label: "Kegiatan Usaha Mikro, Kecil, dan Menengah (UMKM)",
    },
    {
        value: "EN:e3831-Tidak Termasuk Kategori Usaha Keuangan Berkelanjutan",
        label: "Tidak Termasuk Kategori Usaha Keuangan Berkelanjutan",
    },
];
export const refTerkait = [
    {
        value: "11-Terkait dalam rangka kesejahteraan",
        label: "Terkait dalam rangka kesejahteraan",
    },
    { value: "12-Terkait", label: "Related" },
    { value: "20-Tidak Terkait", label: "Un Related" },
];
export const refInterestSubsidy = [
    { value: "00-Non Subsidy", label: "Non Subsidy" },
    { value: "10-Submission", label: "Pengajuan Subsidy Covid" },
    { value: "18-Rejection", label: "Penolakan Subsidy Covid" },
    { value: "19-Reporting", label: "Pelaporan Subsidy Covid" },
];
export const refSebabMacet = [
    { value: "01-Kesulitan Pemasaran", label: "Kesulitan Pemasaran" },
    {
        value: "02-Kesulitan Manajemen dan Permasalahan Tenaga Kerja",
        label: "Kesulitan Manajemen dan Permasalahan Tenaga Kerja",
    },
    {
        value: "03-Perusahaan Grup/Afiliasi yang Sangat Merugikan Debitur",
        label: "Perusahaan Grup/Afiliasi yang Sangat Merugikan Debitur",
    },
    {
        value: "04-Permasalahan Terkait Pengelolaan Lingkungan Hidup19-Reporting",
        label: "Permasalahan Terkait Pengelolaan Lingkungan Hidup",
    },
    {
        value: "05-Penggunaan Dana Tidak Sesuai dengan Perjanjian Kredit",
        label: "Penggunaan Dana Tidak Sesuai dengan Perjanjian Kredit",
    },
    {
        value: "06-Kelemahan Dalam Analisa Kredit",
        label: "Kelemahan Dalam Analisa Kredit",
    },
    { value: "07-Fluktuasi Nilai Tukar", label: "Fluktuasi Nilai Tukar" },
    { value: "08-Itikad Tidak Baik", label: "Itikad Tidak Baik" },
    { value: "09-Force Majeur", label: "Force Majeur" },
    { value: "10-Pailit", label: "Pailit" },
    { value: "11-Uniform Classificationng", label: "Uniform Classification" },
    { value: "99-Lainnya", label: "Lainnya" },
];
export const refSebabRestruktur = [
    {
        value: "01-Penurunan suku bunga kredit",
        label: "Penurunan suku bunga kredit",
    },
    {
        value: "02-Perpanjangan jangka waktu kredit",
        label: "Perpanjangan jangka waktu kredit",
    },
    {
        value: "03-Pengurangan tunggakan pokok kredit",
        label: "Pengurangan tunggakan pokok kredit",
    },
    {
        value: "04-Pengurangan tunggakan bunga kredit",
        label: "Pengurangan tunggakan bunga kredit",
    },
    {
        value: "05-Penambahan fasilitas kredit",
        label: "Penambahan fasilitas kredit",
    },
    {
        value: "06-Konversi kredit menjadi penyertaan modal sementara",
        label: "Konversi kredit menjadi penyertaan modal sementara",
    },
    {
        value: "07-Penambahan fasilitas kredit dan pengurangan tunggakan bunga kredit",
        label: "Penambahan fasilitas kredit dan pengurangan tunggakan bunga kredit",
    },
    {
        value: "08-Penambahan fasilitas kredit dan perpanjangan jangka waktu kredit",
        label: "Penambahan fasilitas kredit dan perpanjangan jangka waktu kredit",
    },
    {
        value: "09-Penambahan fasilitas kredit dan penurunan suku bunga kredit",
        label: "Penambahan fasilitas kredit dan penurunan suku bunga kredit",
    },
    {
        value: "10-Penambahan fasilitas kredit, pengurangan tunggakan bunga kedit dan penurunan suku bunga kredit",
        label: "Penambahan fasilitas kredit, pengurangan tunggakan bunga kedit dan penurunan suku bunga kredit",
    },
    {
        value: "11-Penambahan fasilitas kredit, pengurangan tunggakan bunga kredit dan perpanjangan jangka waktu kredit",
        label: "Penambahan fasilitas kredit, pengurangan tunggakan bunga kredit dan perpanjangan jangka waktu kredit",
    },
    {
        value: "12-Penjadwalan Kembali(Syariah)",
        label: "Penjadwalan Kembali(Syariah)",
    },
    {
        value: "13-Perubahan jadwal pembayaran(Syariah)",
        label: "Perubahan jadwal pembayaran(Syariah)",
    },
    {
        value: "14-Perubahan jumlah angsuran(Syariah)",
        label: "Perubahan jumlah angsuran(Syariah)",
    },
    {
        value: "15-Perubahan jangka waktu(Syariah)",
        label: "Perubahan jangka waktu(Syariah)",
    },
    {
        value: "16-Perubahan nisbah dalam pembiayaan Mudharabah atau Pembiayaan Musyarakah(Syariah)",
        label: "Perubahan nisbah dalam pembiayaan Mudharabah atau Pembiayaan Musyarakah(Syariah)",
    },
    {
        value: "17-Perubahan Porsi Bagi Hasil (PBH) dalam pembiayaan Mudharabah atau Pembiayaan Musyarakah(Syariah)",
        label: "Perubahan Porsi Bagi Hasil (PBH) dalam pembiayaan Mudharabah atau Pembiayaan Musyarakah(Syariah)",
    },
    {
        value: "18-Pemberian potongan(Syariah)",
        label: "Pemberian potongan(Syariah)",
    },
    {
        value: "19-Penambahan dana fasilitas pembiayaan bank(Syariah)",
        label: "Penambahan dana fasilitas pembiayaan bank(Syariah)",
    },
    {
        value: "20-Konversi akad pembiayaan(Syariah)",
        label: "Konversi akad pembiayaan(Syariah)",
    },
    {
        value: "21-Konversi pembiayaan menjadi penyertaan modal pada perusahaan nasabah(Syariah)",
        label: "Konversi pembiayaan menjadi penyertaan modal pada perusahaan nasabah(Syariah)",
    },
    { value: "99-Lainnya", label: "Lainnya" },
];
export const refKualitas = [
    { value: "1", label: "Lancar" },
    { value: "2", label: "Dalam Perhatian Khusus" },
    { value: "3", label: "Kurang Lancar" },
    { value: "4", label: "Diragukan" },
    { value: "5", label: "Macet" },
];
export const refSumberPenghasilan = [
    { value: "1-Gaji", label: "Gaji" },
    { value: "2-Usaha", label: "Usaha" },
    { value: "3-Lainnya", label: "Lainnya" },
];
export const refStatusRumahTinggal = [
    { value: "10-Milik Sendiri", label: "OwnedSelf" },
    { value: "11-Milik Orang Tua (Keluarga)", label: "OwnedParents" },
    { value: "12-Milik Perusahaan (Instansi)", label: "OwnedCompany" },
    { value: "20-Kontrak", label: "Contract" },
    { value: "21-Kos", label: "Kos" },
];
export const refStatusAnggota = [
    { value: "0-Bukan Anggota", label: "Bukan Anggota" },
    { value: "1-Calon Anggota", label: "Member Candidate" },
    { value: "2-Anggota", label: "Member" },
    { value: "3-Anggota Luar Biasa", label: "Member Exceptional" },
    { value: "4-Anggota Pendiri", label: "Member Founder" },
    { value: "9-Keluar Anggota", label: "Keluar Keanggotaan" },
];
export const refJenisRekening = [
    { value: "10-Tabungan", label: "Tabungan" },
    { value: "20-Deposito", label: "Deposito" },
    { value: "30-Pinjaman", label: "Pinjaman" },
];
export const refBankTerkait = [
    { value: "12-Terkait", label: "Related" },
    { value: "20-Tidak Terkait", label: "UnRelated" },
];
export const refJenisAkad = [
    { value: "00", label: "Konvensional" },
    { value: "JK:e16", label: "Sewa Pembiayaan (Finance Lease)" },
    { value: "JK:e17", label: "Jual dan Sewa Balik (Sale and Leaseback)" },
    { value: "JK:e18", label: "Anjak Piutang with Recourse" },
    { value: "JK:e19", label: "Anjak Piutang without Recourse" },
    { value: "JK:e20", label: "Pembelian dengan Pembayaran secara Angsuran" },
    { value: "JK:e21", label: "Pembiayaan Proyek" },
    { value: "JK:e22", label: "Pembiayaan Infrastruktur" },
    { value: "JK:e23", label: "Fasilitas Modal Usaha" },
    { value: "JK:e24", label: "Cara Pembiayaan Lain Dengan Persetujuan OJK" },
    {
        value: "JK:e25",
        label: "Pembiayaan Jual Beli Berdasarkan Prinsip Syariah",
    },
    { value: "JK:e26", label: "Murabahah" },
    { value: "JK:e27", label: "Salam" },
    { value: "JK:e28", label: "Istishna" },
    {
        value: "JK:e29",
        label: "Pembiayaan Jual Beli dengan akad lainnya Berdasarkan Prinsip Syariah",
    },
    {
        value: "JK:e30",
        label: "Pembiayaan Investasi Berdasarkan Prinsip Syariah",
    },
    { value: "JK:e31", label: "Mudharabah" },
    { value: "JK:e32", label: "Musyarakah" },
    { value: "JK:e33", label: "Mudharabah Musytarakah" },
    { value: "JK:e34", label: "Musyarakah Mutanaqisah" },
    {
        value: "JK:e35",
        label: "pembiayaan Investasi dengan akad lainnya Berdasarkan Prinsip Syariah",
    },
    { value: "JK:e36", label: "Pembiayaan jasa Berdasarkan Prinsip Syariah" },
    { value: "JK:e37", label: "Ijarah" },
    { value: "JK:e38", label: "Ijarah Muntahiyah Bittamlik" },
    { value: "JK:e42", label: "Wakalah bil Ujrah" },
    { value: "JK:e46", label: "Qardh" },
    {
        value: "JK:e47",
        label: "Pembiayaan Jasa dengan Akad Lainnya Berdasarkan Prinsip Syariah",
    },
    { value: "JK:e66", label: "Fasilitas Dana" },
    {
        value: "JK:e70",
        label: "Pembelian dengan Pembayaran secara Angsuran - Kartu Kredit",
    },
    {
        value: "JK:e71",
        label: "Pembelian dengan Pembayaran secara Angsuran - Non Kartu Kredit",
    },
    { value: "JK:E73", label: "Buy Now Pay Later (BNPL)" },
];
export const refJenisAsuransi = [
    { value: "01-Jiwa", label: "01-Jiwa" },
    { value: "02-Kebakaran", label: "02-Kebakaran" },
    { value: "03-Kendaraan", label: "03-Kendaraan" },
    { value: "04-Lainnya", label: "04-Lainnya" },
];
export const refStatusParipasu = [
    { value: "Y", label: "Yes" },
    { value: "T", label: "No" },
];
export const refTipeAdmin = [
    { value: "Flat", label: "Flat" },
    { value: "Tiering", label: "Tiering" },
    { value: "Bersyarat", label: "Bersyarat" },
];
export const refAdminTdkAktif = [
    { value: "Ya", label: "Ya" },
    { value: "Tidak", label: "Tidak" },
];
export const refAdminSaldo = [
    { value: "Ya", label: "Ya" },
    { value: "Tidak", label: "Tidak" },
];
export const refBoolean = [
    { value: true, label: "Ya" },
    { value: false, label: "Tidak" },
];
export const refYaTidak = [
    { value: "Ya", label: "Ya" },
    { value: "Tidak", label: "Tidak" },
];
export const refJenisSaldoEfektif = [
    { value: "1-Saldo Rata Rata", label: "Saldo Rata Rata" },
    { value: "2-Saldo Terkecil", label: "Saldo Terkecil" },
    { value: "3-Saldo Terbesar", label: "Saldo Terbesar" },
    { value: "4-Saldo Akhir", label: "Saldo Akhir" },
    { value: "5-Saldo Akhir Bulan Lalu", label: "Saldo Akhir Bulan Lalu" },
    { value: "6-Saldo Harian", label: "Saldo Harian" },
];
export const refBasePinalti = [
    { value: "1-Reguler", label: "Reguler" },
];
export const refMetodePenutupan = [
    { value: "Manual", label: "Manual" },
];
export const refFlagRestricted = [
    { value: "Restricted", label: "Restricted" },
    { value: "UnRestricted", label: "UnRestricted" },
];
export const refOperation = [{ value: "C", label: "C" }];
export const refSandiBiSimpananABA = [
    { value: "20", label: "20" },
];
export const refSandiBiSimpananABP = [
    { value: "01", label: "01" },
];
export const refMetodePerhitungan = [
    { value: "Pro-Rata", label: "Pro-Rata" },
];
export const refJointAccountType = [
    { value: "QQ", label: "QQ" },
];
export const refJenisCoa = [
    { value: "Aktiva", label: "Aktiva" },
    { value: "Kewajiban", label: "Kewajiban" },
    { value: "Modal", label: "Modal" },
    { value: "Pendapatan", label: "Pendapatan" },
    { value: "Biaya", label: "Biaya" },
];
export const refTipeCoa = [
    { value: "G", label: "General" },
    { value: "D", label: "Detail" },
];
export const refPosisiCoa = [
    { value: "D", label: "Debet" },
    { value: "K", label: "Kredit" },
];
export const refReportCoa = [
    { value: "Neraca", label: "Neraca" },
    { value: "Laba Rugi", label: "Laba Rugi" },
    { value: "Neraca Administratif", label: "Neraca Administratif" },
    { value: "Pajak", label: "Pajak" },
];
export const refSrc = [{ value: "TL", label: "TL" }];
export const refMetodePenyusutan = [
    { value: "Otomatis", label: "Otomatis" },
];
